module.exports = __webpack_public_path__ + "img/burrito.67c616e5.webp";